export default __webpack_public_path__ + "static/EdizBarakat-8d53f6e1de5bf0ab19d4e90610133052.png";